import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import DropList from 'components/atoms/DropList';
import Form from 'components/atoms/Form';
import FormGroup from 'components/atoms/FormGroup';
import Icon from 'components/atoms/Icon';
import Message from 'components/atoms/Message';
import { bindActionCreators, Dispatch } from 'redux';
import { tagReassign } from 'services/tags';
import { SetErrorHandlerAction, setErrorHandlerAction } from 'store/actions/errorsActions';
import { PortType, RootState, TagType } from 'types';
import { ActionsType } from 'types/system';
import { renderError } from 'utils/formHandlers';
import { formatServerErrors } from 'utils/formatServerErrors';
import { translate } from 'utils/translate';

interface ReassignTagModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    id?: string;
    data: any;
    actions: ActionsType | undefined;
    port: PortType;
    setErrorHandlerAction: SetErrorHandlerAction;
    tags: TagType[];
}

interface ReassignTagModelState {
    errors: any;

    //unused state
    data: any | null;

    loading: boolean;
    tag: TagType;
    reassignTag?: TagType;
}

class ReassignTagModel extends Component<ReassignTagModelProps, ReassignTagModelState> {
    constructor(props: ReassignTagModelProps) {
        super(props);
        this.state = {
            data: null,
            loading: false,
            errors: {},
            tag: props.data.tag,
        };
    }

    handleChange = (name: string, value: unknown) => {
        const { errors } = this.state;

        this.setState({
            reassignTag: this.props.tags.find((x) => {
                //@ts-ignore
                return x.id === parseInt(value);
            }),
            errors,
        });
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.setState({ errors: {}, loading: true }, () => {
            tagReassign(this.props.port.id, { oldTag: this.state.tag.id, newTag: this.state.reassignTag?.id })
                .then(() => {
                    this.props.actions?.onCancel();
                    this.props.actions?.onConfirm();
                })
                .catch((errors) => {
                    switch (errors.response?.status) {
                        case 422:
                            this.setState({ errors: formatServerErrors(errors), loading: false });
                            break;
                        default:
                            this.setState({ loading: false });
                            this.props.setErrorHandlerAction(errors);
                            break;
                    }

                    return;
                });
        });
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Reassign tags')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>
                    <FormGroup comments={renderError(this.state.errors?.['reassignTag'])} required={false}>
                        <DropList  capitalize
                            name="reassignTag"
                            id="reassignTag"
                            placeholder={translate('Select reassignTag')}
                            value="public"
                            options={this.props.tags
                                .filter((tag) => {
                                    return tag.type === this.state.tag.type && tag.id !== this.state.tag.id;
                                })
                                .map((item) => {
                                    return { label: item.label, value: item.id };
                                })}
                            onChange={this.handleChange}
                        ></DropList>
                    </FormGroup>

                    {this.state.reassignTag && (
                        <Message type="error" className="mt-2">
                            {translate('This operation is irreversible')} <br></br>
                            {translate('are you sure you want to reassign', {
                                count: this.props.data.tag.total,
                                from: this.state.tag.label,
                                to: this.state.reassignTag?.label,
                            })}
                        </Message>
                    )}

                    <div className="flex justify-end">
                        <div className="mt-5 flex gap-3">
                            <Button
                                type="button"
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button
                                disabled={this.state.loading || !this.state.reassignTag}
                                loading={this.state.loading}
                                type="submit"
                                className="px-4 py-2 bg-primary-submit rounded-md text-white"
                            >
                                {translate('Save')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}
const mapStateToProps = (state: RootState) => ({
    port: state.port.port,
    language: state.user.user.language,
    tags: state.port.tags,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReassignTagModel);
